import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text, Heading, StyleReset } from '@rebeldotcom/components'
import { InfoCollector } from '@rebeldotcom/ui'
import { MDXProvider } from '@mdx-js/react'
import Layout from '../components/layout'
import { SEO } from '../components/seo'
import { Metadata } from '../components/metadata'

const Wrapper = props => (
  <Box display="block" justifyContent="center" my={5} {...props} />
)

const components = {
  Box,
  Text,
  Heading,
  wrapper: Wrapper,
  Metadata,
  InfoCollector,
}

const MarkdownPage = ({
  children,
  pageContext: {
    frontmatter: { seo, path },
  },
}) => {
  return (
    <Layout location={path}>
      {seo && (
        <SEO description={seo.description} location={path} title={seo.title} />
      )}
      <MDXProvider components={components}>
        <Box
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          py={5}
        >
          <StyleReset flexDirection="column" maxWidth="containers.lg">
            {children}
          </StyleReset>
        </Box>
      </MDXProvider>
    </Layout>
  )
}

MarkdownPage.defaultProps = {
  children: [],
  pageContext: {
    frontmatter: {
      seo: {},
    },
  },
}
MarkdownPage.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  pageContext: PropTypes.shape({
    frontmatter: PropTypes.shape({
      path: PropTypes.string.isRequired,
      seo: PropTypes.shape({
        description: PropTypes.string.isRequired,
        imageUrl: PropTypes.string,
        title: PropTypes.string.isRequired,
      }).isRequired,
    }),
  }),
}

export default MarkdownPage
